<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="确认收货" left-arrow fixed
                     @click-left="back"/>
        <h5>商品信息</h5>
        <van-row v-for="(item,index) in order.carts" class="recorder-itrm">
            <van-row class="pro-bd">
                <van-col span="10">
                    <img :src="item.imges"/>
                </van-col>
                <van-col span="14">
                    <p>{{item.goodsName}}</p>
                    <p><span>商品数量</span>{{item.count}}</p>
                    <p><span>积分</span>{{item.integral}}</p>
                </van-col>
            </van-row>
        </van-row>
            <van-cell title="订单状态" :value="order.igoStatusName" />
            <van-cell title="支付方式" :value="order.igoPayment" />
            <van-cell title="总积分" :value="order.igoTotalIntegral" />
        <div class="btn-hd">
            <!--url="#/user/order/arrival"-->
            <van-button size="large" @click="saveShouhuo">确认收货</van-button>
        </div>

    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Picker, Popup} from "vant"

    export default {
        name: "userIntegralOrderReceive",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Popup.name]: Popup,
            [Picker.name]: Picker
        },
        data() {
            return {
                id: this.$route.query.id,
                order: {},
            };
        },
        mounted: function () {
            let that = this
            that.getGoods()
        },
        methods: {
            getGoods() {
                let that = this
                that.$api.post(
                    that.jumuc.integral.orderDetail,
                    {"id": that.id},
                    successRes => {
                        that.order = successRes.data
                    }
                )
            },
            back() {
                history.back();
            }, saveShouhuo() {
                let that = this
                that.$api.post(
                    that.jumuc.integral.confirmOrder,
                    {"id": that.id},
                    successRes => {
                        if(successRes.success){
                            that.$router.push({"path": "/user/integral/order"})
                        }else{
                            that.$toast(successRes.msg);
                        }
                    }
                )
            }
        },
    };
</script>
<style lang="less">
    @bule-thame: #3C6EEB;

    .jump-warphd {
        h5 {
            color: @bule-thame;
            font-size: 16px;
            border-bottom: 1px solid #f7f7f7;
            padding: 10px;
        }
        .pro-bd {
            padding: 10px;
            border-bottom: 1px solid #f7f7f7;
            img {
                width: 90%;
            }
            p {
                font-size: 14px;
                line-height: 28px;
                span {
                    display: inline-block;
                    min-width: 60px;
                    margin-right: 5px;
                }
            }
        }
        .btn-hd {
            padding: 40px 20px;
            border-top: 1px solid #f7f7f7;
            button {
                color: #fff;
                background-color: @bule-thame;
                border-color: @bule-thame;
            }
        }
        .van-cell:not(:last-child)::after {
            border: none;
        }
        .recorder-itrm{
            background-color: #fff;
        }
    }
</style>
